import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { Col, Row, Label, FormGroup, Input, Card, CardBody } from "reactstrap";
import { Form, Field } from "react-final-form";

import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader.js";
import "../../assets/custom css/loadoverlay.scss";
import Alerts from "../../components/Alerts/alerts.js";

import ConfigurationService from "./configuration.service.js";
import AuthService from "../Authentication/auth.service.js";
import PermissionAccess from '../../PermissionAccess/Access.js';

const TabGenralConfig = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fetch_items_time, setfetch_items_time] = useState("");
  const [fetch_stocks_time, setfetch_stocks_time] = useState("");
  const [submit_invoice_time, setsubmit_invoice_time] = useState("");
  const [submit_credit_note_time, setsubmit_credit_note_time] = useState("");
  const [backup_cancel_invoice_time, setbackup_cancel_invoice_time] = useState("");
  const [configs, setConfig] = useState([]);
  const { t, i18n } = useTranslation();
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    getAutoCount();
  }, []);

  function getAutoCount() {
    ConfigurationService.GetAutoCount(authData.sessionID).then((response) => {
      // console.log("API Response:-", response);
      if (response.data.status) {
        const [rec_data] = response.data.data;
        setConfig(rec_data);
        setfetch_items_time(rec_data.fetch_items_time);
        setfetch_stocks_time(rec_data.fetch_stocks_time);
        setsubmit_invoice_time(rec_data.submit_invoice_time);
        setsubmit_credit_note_time(rec_data.submit_credit_note_time);
        setbackup_cancel_invoice_time(rec_data.backup_cancel_invoice_time);
        
      } else {
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          alert(t("Unable to retrieve configurations at the moment."));
        }
      }
    }, (error) => {
      alert(t("Unable to retrieve configurations at the moment."));
    });
  }

  function handleSave(values) {
    // console.log("Form Values:-", values);
    var payloadData = {
      functionName: "SetAutoCount",
      postData: {
        baseURL: values.baseURL,
        USER_ID: values.USER_ID,
        PASSWORD: values.PASSWORD,
        fetch_items_time: fetch_items_time,
        fetch_stocks_time: fetch_stocks_time,
        submit_invoice_time: submit_invoice_time,
        submit_credit_note_time: submit_credit_note_time,
        backup_cancel_invoice_time: backup_cancel_invoice_time,
      },
    };
    ConfigurationService.SetAutoCount(authData.sessionID, payloadData).then((response) => {
      //iph todo: 47
      //console.log("API Response:-", response);
      setLoading(false);
      if (response.data.status) {
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message);
        } else {
          Alerts.swalSuccessAlert(t("Configuration updated successfully."));
        }
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          } else {
            Alerts.swalErrorAlert(response.data.message);
          }
        } else {
          Alerts.swalErrorAlert(t("Error: Can't update configuration at the moment. Please try again later."));
        }
      }
    }, (error) => {
      setLoading(false);
      const resMessage = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      //iph todo: 47
      //console.log("Error:-", error);
      Alerts.swalErrorAlert(t("Network Operation failed."));
    });
  }

  const validateFtn = (values) => {
    const errors = {};
    if (!values.baseURL) {
      errors.baseURL = t("Base URL Required.");
    }
    if (!values.USER_ID) {
      errors.USER_ID = t("USER ID Required.");
    }
    if (!values.PASSWORD) {
      errors.PASSWORD = t("PASSWORD Required.");
    }
    return errors;
  };

  return (
    <Fragment>
      <Card className="main-card mb-3">
        <CardBody className="col-md-8">
          <Form
            initialValues={configs}
            validate={validateFtn}
            onSubmit={handleSave}
            FormState
            render={({ handleSubmit, values, submitting, validating, valid, form: { getState } }) => (
              <form onSubmit={handleSubmit}>
                <LoadingOverlay tag="div" active={loading}
                  styles={{ overlay: (base) => ({ ...base }) }}
                  spinner={<DNALoader />}>
                  <Row form>
                    <Col md={12}>
                      <FormGroup>
                        <Field name="baseURL">
                          {({ input, meta }) => (
                            <div>
                              <div className="row mb-3">
                                <Label for="baseURL" className="col-sm-2 col-form-label">{t('Base URL')}</Label>
                                <div className="col-sm-10">
                                  <Input {...input} type="text"
                                    invalid={meta.error && meta.touched}
                                    placeholder={t('Base URL')}
                                  />
                                  {meta.error && meta.touched &&
                                    <span className="text-danger">{meta.error}</span>}
                                </div>
                              </div>
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                      <FormGroup>
                        <Field name="USER_ID">
                          {({ input, meta }) => (
                            <div>
                              <div className="row mb-3">
                                <Label for="USER_ID" className="col-sm-2 col-form-label">{t('USER ID')}</Label>
                                <div className="col-sm-10">
                                  <Input {...input} type="USER_ID"
                                    invalid={meta.error && meta.touched}
                                    placeholder={t('USER ID')}
                                  />
                                  {meta.error && meta.touched &&
                                    <span className="text-danger">{meta.error}</span>}
                                </div>
                              </div>
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                      <FormGroup>
                        <Field name="PASSWORD">
                          {({ input, meta }) => (
                            <div>
                              <div className="row mb-3">
                                <Label for="PASSWORD" className="col-sm-2 col-form-label">{t('PASSWORD')}</Label>
                                <div className="col-sm-10">
                                  <Input {...input} type="PASSWORD"
                                    invalid={meta.error && meta.touched}
                                    placeholder={t('PASSWORD')}
                                  />
                                  {meta.error && meta.touched &&
                                    <span className="text-danger">{meta.error}</span>}
                                </div>
                              </div>
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                      <FormGroup>
                        <Field name="fetch_items_time">
                          {({ input, meta }) => (
                            <div>
                              <div className="row mb-3">
                                <Label for="fetch_items_time" className="col-sm-2 col-form-label">{t('Fetch Items Time')}</Label>
                                <div className="col-sm-10">
                                  <select {...input}
                                    value={fetch_items_time}
                                    onChange={event => setfetch_items_time(event.target.value)}
                                    className="form-select" name="fetch_items_time"
                                  >
                                    <option disabled={true} value="">{t('--Choose a schedule--')}</option>
                                    <option value="* * * * *">{t('Every minute')}</option>
                                    <option value="*/5 * * * *">{t('Every 5 minutes')}</option>
                                    <option value="*/15 * * * *">{t('Every 15 minutes')}</option>
                                    <option value="0,30 * * * *">{t('Twice per hour')}</option>
                                    <option value="0 * * * *">{t('Once per hour')}</option>
                                    <option value="0 0,12 * * *">{t('Twice per day')}</option>
                                    <option value="0 0 * * *">{t('Once per day')}</option>
                                    <option value="0 0 * * 0">{t('Once per week')}</option>
                                    <option value="0 0 1 * *">{t('Once per month')}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                      <FormGroup>
                        <Field name="fetch_stocks_time">
                          {({ input, meta }) => (
                            <div>
                              <div className="row mb-3">
                                <Label for="fetch_stocks_time" className="col-sm-2 col-form-label">{t('Fetch Stocks Time')}</Label>
                                <div className="col-sm-10">
                                  <select {...input}
                                    value={fetch_stocks_time}
                                    onChange={event => setfetch_stocks_time(event.target.value)}
                                    className="form-select" name="fetch_stocks_time"
                                  >
                                    <option disabled={true} value="">{t('--Choose a schedule--')}</option>
                                    <option value="* * * * *">{t('Every minute')}</option>
                                    <option value="*/5 * * * *">{t('Every 5 minutes')}</option>
                                    <option value="*/15 * * * *">{t('Every 15 minutes')}</option>
                                    <option value="0,30 * * * *">{t('Twice per hour')}</option>
                                    <option value="0 * * * *">{t('Once per hour')}</option>
                                    <option value="0 0,12 * * *">{t('Twice per day')}</option>
                                    <option value="0 0 * * *">{t('Once per day')}</option>
                                    <option value="0 0 * * 0">{t('Once per week')}</option>
                                    <option value="0 0 1 * *">{t('Once per month')}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                      <FormGroup>
                        <Field name="submit_invoice_time">
                          {({ input, meta }) => (
                            <div>
                              <div className="row mb-3">
                                <Label for="submit_invoice_time" className="col-sm-2 col-form-label">{t('Invoice Submission Time')}</Label>
                                <div className="col-sm-10">
                                  <select {...input}
                                    value={submit_invoice_time}
                                    onChange={event => setsubmit_invoice_time(event.target.value)}
                                    className="form-select" name="submit_invoice_time"
                                  >
                                    <option disabled={true} value="">{t('--Choose a schedule--')}</option>
                                    <option value="* * * * *">{t('Every minute')}</option>
                                    <option value="*/5 * * * *">{t('Every 5 minutes')}</option>
                                    <option value="*/15 * * * *">{t('Every 15 minutes')}</option>
                                    <option value="0,30 * * * *">{t('Twice per hour')}</option>
                                    <option value="0 * * * *">{t('Once per hour')}</option>
                                    <option value="0 0,12 * * *">{t('Twice per day')}</option>
                                    <option value="0 0 * * *">{t('Once per day')}</option>
                                    <option value="0 0 * * 0">{t('Once per week')}</option>
                                    <option value="0 0 1 * *">{t('Once per month')}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                      <FormGroup>
                        <Field name="submit_credit_note_time">
                          {({ input, meta }) => (
                            <div>
                              <div className="row mb-3">
                                <Label for="submit_credit_note_time" className="col-sm-2 col-form-label">{t('Credit Note Submission Time')}</Label>
                                <div className="col-sm-10">
                                  <select {...input}
                                    value={submit_credit_note_time}
                                    onChange={event => setsubmit_credit_note_time(event.target.value)}
                                    className="form-select" name="submit_credit_note_time"
                                  >
                                    <option disabled={true} value="">{t('--Choose a schedule--')}</option>
                                    <option value="* * * * *">{t('Every minute')}</option>
                                    <option value="*/5 * * * *">{t('Every 5 minutes')}</option>
                                    <option value="*/15 * * * *">{t('Every 15 minutes')}</option>
                                    <option value="0,30 * * * *">{t('Twice per hour')}</option>
                                    <option value="0 * * * *">{t('Once per hour')}</option>
                                    <option value="0 0,12 * * *">{t('Twice per day')}</option>
                                    <option value="0 0 * * *">{t('Once per day')}</option>
                                    <option value="0 0 * * 0">{t('Once per week')}</option>
                                    <option value="0 0 1 * *">{t('Once per month')}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                      <FormGroup>
                        <Field name="backup_cancel_invoice_time">
                          {({ input, meta }) => (
                            <div>
                              <div className="row mb-3">
                                <Label for="backup_cancel_invoice_time" className="col-sm-2 col-form-label">{t('Backup Cancel Invoice Time')}</Label>
                                <div className="col-sm-10">
                                  <select {...input}
                                    value={backup_cancel_invoice_time}
                                    onChange={event => setbackup_cancel_invoice_time(event.target.value)}
                                    className="form-select" name="backup_cancel_invoice_time"
                                  >
                                    <option disabled={true} value="">{t('--Choose a schedule--')}</option>
                                    <option value="0 0,6,12,18 * * *">{t('4 times per day (every 6 hours)')}</option>
                                    <option value="0 0,8,16 * * *">{t('3 times per day (every 8 hours)')}</option>
                                    <option value="0 0,12 * * *">{t('Twice per day')}</option>
                                    <option value="0 0 * * *">{t('Once per day')}</option>
                                    <option value="0 0 * * 0">{t('Once per week')}</option>
                                    <option value="*/30 * * * *">{t('Every 30 minutes')}</option>
                                    <option value="*/15 * * * *">{t('Every 15 minutes')}</option>
                                    <option value="*/5 * * * *">{t('Every 5 minutes')}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                      <FormGroup>
                        <div className="d-flex justify-content-center EditData">
                          <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-light btn-hover-shine me-3 mt-3">{t('Cancel')}</button>
                          <button className="btn btn-custom-color btn-hover-shine me-3 mt-3" type="submit" disabled={!valid}>{t('Save')}</button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </LoadingOverlay>
              </form>
            )}
          />
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default TabGenralConfig;